import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getAccount, saveAccount, updateAccount } from './AccountService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Checkbox, FormControlLabel } from '@mui/material';

import MembershipList from '../Memberships/MembershipList';
// import SubscriptionList from '../Subscriptions/SubscriptionList';
import GroupList from '../Groups/GroupList';
import AccountUserList from './AccountUserList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const AccountDetail = (): JSX.Element => {
  //const { sectionid, itemid } = useParams();
  //   const { sectionid = '' } = useParams<{ sectionid: string }>();
  //   const { itemid = '' } = useParams<{ itemid: string }>();

  const [accountName, setAccountName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [enabled, setEnabled] = useState(false); // Initialize as false
  const navigate = useNavigate();
  const { accountid } = useParams();

  function clearAccountDetailsForm() {
    setAccountName('');
    setFirstName('');
    setLastName('');
    setEmail('');
    setEnabled(false);
  }

  const cancelSaveOrUpdateAccount = () => {
    clearAccountDetailsForm();
    navigate('/system/dashboard/accounts');
  };

  function saveOrUpdateAccount(e) {
    e.preventDefault();

    const account = { accountName, firstName, lastName, email, enabled };

    if (accountid) {
      updateAccount(accountid, account)
        .then(() => {
          navigate('/system/dashboard/accounts');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveAccount(account)
        .then(() => {
          navigate('/system/dashboard/accounts');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (accountid) {
      console.log('accountid exists: ', accountid);
      getAccount(accountid)
        .then((response) => {
          console.log(response.data);
          setAccountName(response.data.accountName);
          setFirstName(response.data.firstName);
          setLastName(response.data.lastName);
          setEmail(response.data.email);
          setEnabled(response.data.enabled);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [accountid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Accounts
            </Link>
            <Typography color="text.primary">Account Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Account Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Account Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'accountName'}
                  fullWidth
                  value={accountName} // Use the 'sequence' state variable as the value
                  onChange={(event) => setAccountName(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  First Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'firstName'}
                  fullWidth
                  value={firstName} // Use the 'name' state variable as the value
                  onChange={(event) => setFirstName(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Last Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'lastName'}
                  fullWidth
                  value={lastName} // Use the 'name' state variable as the value
                  onChange={(event) => setLastName(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Email
                </Typography>
                <TextField
                  variant="outlined"
                  name={'email'}
                  fullWidth
                  value={email} // Use the 'name' state variable as the value
                  onChange={(event) => setEmail(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Enabled?
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enabled} // Use the 'enabled' state variable as the checked value
                      onChange={(event) => setEnabled(event.target.checked)} // Update the 'enabled' state variable on change
                      name="enabled" // Name for the checkbox (optional)
                    />
                  }
                  label="Enabled"
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateAccount}>Cancel</Button>
                  <Button onClick={saveOrUpdateAccount}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box>
          <MembershipList />
          {/* <SubscriptionList /> */}
          <GroupList />
          <AccountUserList />
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default AccountDetail;
